<template>
  <form>
    <h4 class="card-title">{{$t('medium_grant.technical__4_reminder_of_pa')}}</h4>
    <p>
      {{$t('medium_grant.technical__4_reminder_of_pa_sub')}}
    </p>
    <div class="row">
      <div class="col-lg-12">
        <base-input>
            <textarea
              class="form-control"
              :placeholder="$t('medium_grant.general__write_here')"
              v-model="GrantForm.model.technical.backgroundOfPaConservation"
            >
            </textarea>
        </base-input>
      </div>
    </div>
  </form>
</template>
<script>
  import {GrantForm} from "@/services";

  export default {
    data() {
      return {
        GrantForm
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      }
    }
  }
</script>